import React from 'react';
import { Navigate, Outlet } from 'react-router';

import { useCurrentMember } from '../hooks/use-current-member';
import { useSpaceOutlet } from '../app/space-outlet';
import { spacePath } from '../app/paths';

/**
 * Pathless layout route keeping guests out of the space-wide sections.
 *
 * Reads the space from the outlet context rather than a prop, because a route
 * element receives no props — and re-emits that context, because a nested
 * <Outlet> does not forward it automatically.
 */
export const MembersOnlyRoute: React.FC = () => {
  const context = useSpaceOutlet();
  const currentMember = useCurrentMember();

  if (currentMember?.role === 'guest') {
    return <Navigate to={spacePath(context.space._id)} replace />;
  }

  return <Outlet context={context} />;
};
